import { render, staticRenderFns } from "./NotificationsCatalog.vue?vue&type=template&id=d86addd8&scoped=true&"
import script from "./NotificationsCatalog.vue?vue&type=script&lang=js&"
export * from "./NotificationsCatalog.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsCatalog.vue?vue&type=style&index=0&id=d86addd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86addd8",
  null
  
)

export default component.exports